import { newTracker, trackStructEvent } from '@snowplow/browser-tracker';

export class Mamka {
  private nameSpace: string;

  private category: string;

  constructor(nameSpace: string, category: string) {
    this.nameSpace = nameSpace;
    this.category = category;

    newTracker(nameSpace, 'avsplow.com', {
      appId: 'tp_widgets',
      encodeBase64: false,
      postPath: '/a/j',
      contexts: {
        webPage: false,
        session: false,
        performanceTiming: false,
        gaCookies: false,
        clientHints: false,
      },
    });
  }

  send = <T>(action: string, metrics: T) => {
    // Отправляем метрики только в production
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    const customContext = {
      schema: 'event',
      data: metrics,
    };

    trackStructEvent(
      {
        category: this.category,
        action,
        property: '',
        value: undefined,
        context: [customContext],
      },
      [this.nameSpace],
    );
  };
}
